import React from "react";
import { useState } from "react";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import SwapHorizontalCircleSharpIcon from "@mui/icons-material/SwapHorizontalCircleSharp";
import { useSelector } from "react-redux";
import failimg from "../../../assets/images/wh-cross.svg";
import { useDispatch } from "react-redux";
import { setToolkitUrl } from "../../../Redux/Actions/VideoHighlightAction";
import { setShowToolkit } from "../../../Redux/Actions/VideoHighlightAction";
function Toolkit() {
  const { toolkitUrl, showToolkitSecond } = useSelector(
    (state) => state?.videoHighlightData
  );
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();

  const bounds = {
    left: -350,
    top: -150,
    right: 350,
    bottom: 220,
  };
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleCrossClick = () => {
    setShowToolkit(dispatch, false);
    if (!showToolkitSecond) {
      setToolkitUrl(dispatch, []);
    }
  };

  return (
    <Draggable bounds={bounds}>
      <Resizable
        defaultSize={{
          width: 300,
          height: 300,
        }}
        style={{
          position: "absolute",
          background: `url(${toolkitUrl[0]})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          cursor: "move",
        }}
        lockAspectRatio={true}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isHovered && (
          <>
            <img
              src={failimg}
              alt="success"
              className="successimg-new"
              style={{ cursor: "pointer" }}
              onClick={handleCrossClick}
            />
            <SwapHorizontalCircleSharpIcon
              style={{
                position: "absolute",
                top: "25%",
                left: "-15px",
                color: "whitesmoke",
                fontSize: "2rem",
                cursor: "pointer",
              }}
            />
          </>
        )}
      </Resizable>
    </Draggable>
  );
}

export default Toolkit;
